export default __webpack_public_path__ + "static/prettier-23d5abb4bb2f1e7abfdf880c7a853e63.png";